module.exports = __webpack_public_path__ + "img/logo-icon.06f72bd1.png";